'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import SweetAlert from 'react-bootstrap-sweetalert';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import $ from 'jquery';
import { getHyphenDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils'; 
import download from 'js-file-download';

// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent="";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class ChagridExportsData extends Component {
  constructor(props) {
    super(props);
      this.state = {
        modules : AllModules,
        defaultColDef: {
            sortable: true,
            filter: true,
            editable: true,
        },
        eventAction: null,
        show: false,
        frameworkComponents : {
        },
        modified_by:"",
        basicTitle:'',
        reasonforceclose:"",
        bulkslide:"",
        file:"",
        uploadFile:"",
        basicType:"default",
        loadshow:'show-n',
        forceCloseRowNode : "",
        forceclosedata:"",
        csvcontent:"",
        sliderForceCloseTranslate:"",
        overly:'',
        rowData:[],
        bulkslide:"",
        showDiv:"",
        uploadDivWidth:"",
        mapinfo:"",
        dealer:"",
        sliderCommentTranslate:"",
        commentsRowData:"",
        consignment_code:"",
        sliderRouteTranslate:"",
        maptruckno:"",
        routeTruck:	"",
        rownode:"",
        googelRoutes:"",
        file:"",
        rowSelection:'multiple',
        sliderForceCloseTranslate:"",
        maptruckno:"",
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
            statusBar: {
        statusPanels: [
          {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left"
          },
          {
          statusPanel: "agTotalRowCountComponent",
          align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
        ]
            },
        paginationPageSize:200,
        geofencelist:[],
        geoFenceData:"",
        sideBar: {
          toolPanels: [
            {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel"
            },
            {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel"
            }
          ]
        },
        animateRows: true,
        dept_code:"",
        pagetitle:"",
        markDeliverRowNode : "",
        markDeliverData:"",
        sliderMarkDeliverTranslate:"",
        csvData:0,
        overly:"show-m",
        loadshow:"show-m",
        holidayEvents : [],
        showCalendar : "show-m",
        showGridData : "show-m",
        chaRowData : [],
        invoiceData:[],
        ccSlider : "", 
        jobNo : "",
        ccData : [],
        cc_docs : "",
        //components : {datepicker:getDatePicker()}
    }
    this.downloadRingiFile = this.downloadRingiFile.bind(this);
    this.changeDocFileHandler = this.changeDocFileHandler.bind(this);
    this.uploadCCFileFormHandler = this.uploadCCFileFormHandler.bind(this);
}
componentDidMount(){

    var chaRowData = this.props.chaRowData;
    console.log(chaRowData,"chaRowData")
    this.setState({
        chaRowData : chaRowData,
    })
}
onRecommGridReady = params => {
    this.gridApi = params.api;  
    //console.log("Grid is: ", params);
    this.gridColumnApi = params.columnApi;
};
onRecommGridState = () =>{
    //console.log(this.gridApi);

    /*Get  Current Columns State and Store in this.colState */
    this.colState = this.gridColumnApi.getColumnState();

    /*Get Current RowGroup Columns State and Store in this.rowGroupState */
    this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

    /*Get Current Pivot Columns State and Store in this.pivotColumns, 
    * User should enable the Pivot mode.*/
    this.pivotColumns = this.gridColumnApi.getPivotColumns();
            
    /*Get Current Filter State and Store in window.filterState */
    window.filterState = this.gridApi.getFilterModel();
    this.gridApi.setFilterModel(window.filterState);
}

onClickHideAll(){
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",
    invoiceData:[],
    ccSlider:"",
    jobNo:"",
    cc_docs:""
    
    });
    
}

showGrid(){
    this.setState({
        showCalendar : "show-n",
        showGridData  : "show-m"
    })
}

closeAlert = () => {
    this.setState({
        show: false
    });
}



viewDetails(e){
    if(e.colDef.field == "invoiceData")
    {
        var invData = [];
        if(e.data.invoiceData !=undefined && e.data.invoiceData !='')
        {
            var invoiceData = JSON.parse(e.data.invoiceData);
            if(invoiceData !=undefined && invoiceData.length > 0)
            {
                invData = invoiceData;
            }
        }
        var sliderTitle = e.data.job_no+" - Pre alert documents";
        this.setState({
            overly :"show-m",
            invoiceData:invData,
            bulkslide : "slider-translate-40p",
            sliderTitle : sliderTitle
        })
    }
    if(e.colDef.field == "shipping_bill")
    {
        var ringiFile = e.data.shipping_bill
        if(ringiFile !='')
        {
            var rngParam = {
                ringiFile : ringiFile,
            }
            redirectURL.post("/consignments/downloadExportsRingiFile",rngParam,{
                responseType: 'blob'
            }).then((response)=>{
                console.log("dowlad response ",response)
                download(response.data, ringiFile)
            }).catch(function(error){
                console.log(error);
            })
        }
    }
    if(e.colDef.field == "ccData")
    {
        var ccData = [];
        if(e.data.ccData !=undefined && e.data.ccData !='')
        {
            ccData = JSON.parse(e.data.ccData);
        }
        var sliderTitle = e.data.job_no+" - Custom clearance documents";
        this.setState({
            overly :"show-m",
            ccData:ccData,
            bulkslide : "slider-translate-40p",
            sliderTitle : sliderTitle,
            ccSlider : 1,
            jobNo : e.data.job_no,
        })
    }
    if(e.colDef.field == "custom_duty_paid")
    {
        var custom_duty_paid = e.data.custom_duty_paid;
        if(custom_duty_paid !="yes")
        {
            if(e.data.ccData !=undefined && e.data.ccData !='')
            {
                var params = {
                    rowId : e.data._id,
                    custom_duty_paid : "yes",
                }
                redirectURL.post("/consignments/updateChaCustomDutyStatus",params).then((response)=>{
                    this.setState({
                        basicTitle:"Success",
                        basicType : "success",
                        show : true,
                        cc_docs:"",
                    });
                    window.location.reload();
                }).catch((e)=>{
                    console.log(e);
                })
            }
        }
    }
}

downloadRingiFile = (ringiFile) => {
    //console.log(ringiFile)
    if(ringiFile !='')
    {
        var rngParam = {
            ringiFile : ringiFile,
        }
        redirectURL.post("/consignments/downloadRingiFile",rngParam,{
            responseType: 'blob'
        }).then((response)=>{
            console.log("dowlad response ",response)
            download(response.data, ringiFile)
        }).catch(function(error){
            console.log(error);
        })
    }
}
changeDocFileHandler = (e) => {
    console.log(e);
    this.setState({
        cc_docs : e.target.files[0]
    });
}
uploadCCFileFormHandler(event){
    event.preventDefault();
    var jobNo = this.state.jobNo;
    if(jobNo !=undefined && jobNo !='')
    {
        if(this.state.cc_docs !=undefined && this.state.cc_docs !='')
        {
            let saveData = new FormData();
            saveData.append("cc_docs", this.state.cc_docs);
            saveData.append("job_no", this.state.jobNo);
            saveData.append("username", localStorage.getItem("username"));
            redirectURL.post("/consignments/uploadChaCCDocuments",saveData,{
                headers:{
                    'content-type': 'multipart/form-data'
                }
            }).then((response)=>{
                var chaRowData = this.state.chaRowData;
                var ccDetails = [];
                var filteredData = chaRowData.filter(rec => (rec.job_no == jobNo));
                try{
                    if(filteredData[0].ccData !=undefined && filteredData[0].ccData !='')
                    {
                        var ccData = JSON.parse(filteredData[0].ccData);
                        for(var r=0;r<ccData.length;r++)
                        {
                            ccDetails.push({
                                "custom_clearance_file" : ccData[r].custom_clearance_file
                            });
                        }
                    }
                }catch(e){
                    console.log(e);
                }
                ccDetails.push({
                    "custom_clearance_file" : this.state.cc_docs.name
                });
                $("#other_docs").val("");
                this.setState({
                    basicTitle:"Success",
                    basicType : "success",
                    show : true,
                    ccData:ccDetails,
                    cc_docs:"",
                });
            }).catch((e)=>{
                console.log(e);
            })
        }
        else
        {
            this.setState({
                basicTitle:"File should not be empty",
                basicType : "warning",
                show : true
            });
        }
    }
    else
    {
        this.setState({
            basicTitle:"Something Went wrong, Please try again",
            basicType : "warning",
            show : true
        });
    }
}
  render() {
    var columnwithDefs = [    
        {
            field:'_id',
            headerName:'',
            colId:"_id",
            //pinned:"left",
            width: 72,
            cellRenderer:function(params){
                let basestring = params.data._id;
                let encryptedstring = window.btoa(basestring);
                var htmloption = '<a href="/editchaaircargoexportsform/'+encryptedstring+'/2" class="custom-btn label label-success"><i class="icofont icofont-edit"></i> Edit</a>';
                return htmloption;
            }            
        }, 
        // {
        //     headerName: "BOE Documents",
        //     field: "ccData",
        //     width:150,
        //     filter: true,
        //     resizable: true,
        //     cellRenderer:function(params){
        //         var htmloption = '<button class="btn btn-warning" style="padding-top:0px">Add/View</button>';
        //         return htmloption;
        //     }         
        // },   
        // {
        //     headerName: "Custom Duty Paid",
        //     field: "custom_duty_paid",
        //     width:150,
        //     filter: true,
        //     resizable: true,
        //     cellRenderer:function(params){
        //         var htmloption = '<button class="btn btn-info" style="padding-top:0px">Mark As Paid</button>';
        //         if(params.data.custom_duty_paid == undefined || params.data.custom_duty_paid =='' || params.data.custom_duty_paid == 'no')
        //         {
        //             if(params.data.ccData !=undefined && params.data.ccData !='')
        //             {
        //                 return htmloption;
        //             }
        //         }
        //         else
        //         {
        //             return params.data.custom_duty_paid;
        //         }
        //     }     
        // },
        {
            headerName: "Job No",
            field: "job_no",
            width:160,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Date",
            field: "date",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.date !=undefined && params.data.date !='')
                {
                    return moment.parseZone(params.data.date).format("DD-MM-YYYY")
                }
            }
        },
        {
            headerName: "Department Name",
            field: "dept_name",
            width:120,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Indenter Name",
            field: "indenter_name",
            width:130,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Mobile No",
            field: "mobile",
            width:100,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Indenter Email",
            field: "indenter_email",
            width:130,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "CHA",
            field: "assign_to_cha",
            width:180,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "ATA IGI Airport",
            field: "ata_igi_airport",
            width:120,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                try{
                    if(params.data.ata_igi_airport_date !='' && params.data.ata_igi_airport_date !=undefined)
                    {
                        return getHyphenDDMMYYYY(params.data.ata_igi_airport_date);
                    }
                }
                catch(e){
                }
            }            
        },
        {
            headerName: "Checklist Date",
            field: "checklist_filling_date",
            width:120,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                try{
                    if(params.data.checklist_filling_date !='' && params.data.checklist_filling_date !=undefined)
                    {
                        return getHyphenDDMMYYYY(params.data.checklist_filling_date);
                    }
                }
                catch(e){
                }
            }            
        },
        {
            headerName: "Shipping Bill No",
            field: "shipping_bill_no",
            width:120,
            filter: true,
            resizable: true,          
        },
        {
            headerName: "Shipping Bill Date",
            field: "shipping_bill_date",
            width:120,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                try{
                    if(params.data.shipping_bill_date !='' && params.data.shipping_bill_date !=undefined)
                    {
                        return getHyphenDDMMYYYY(params.data.shipping_bill_date);
                    }
                }
                catch(e){
                }
            }            
        },
        {
            headerName: "Shipping Bill",
            field: "shipping_bill",
            width:120,
            filter: true,
            resizable: true,          
        },
        {
            headerName: "LEO Date",
            field: "leo_date",
            width:120,
            filter: true,
            resizable: true, 
            valueGetter: function(params){
                try{
                    if(params.data.leo_date !='' && params.data.leo_date !=undefined)
                    {
                        return getHyphenDDMMYYYY(params.data.leo_date);
                    }
                }
                catch(e){
                }
            }          
        },
        {
            headerName: "DBK Amount",
            field: "dbk_amount",
            width:120,
            filter: true,
            resizable: true,          
        },
        {
            headerName: "RODTEP Amount",
            field: "rodtep_amount",
            width:120,
            filter: true,
            resizable: true,          
        },
        {
            headerName: "Demmurage Charges",
            field: "demmurage_charges",
            width:120,
            filter: true,
            resizable: true,          
        },
        {
            headerName: "Demmurage Charges Amount",
            field: "demmurage_charges_amount",
            width:150,
            filter: true,
            resizable: true,          
        },
        {
            headerName: "Demmurage Start Date",
            field: "demmurage_start_date",
            width:120,
            filter: true,
            resizable: true, 
            valueGetter: function(params){
                try{
                    if(params.data.demmurage_start_date !='' && params.data.demmurage_start_date !=undefined)
                    {
                        return getHyphenDDMMYYYY(params.data.demmurage_start_date);
                    }
                }
                catch(e){
                }
            }          
        },
        {
            headerName: "Demmurage End Date",
            field: "demmurage_end_date",
            width:120,
            filter: true,
            resizable: true, 
            valueGetter: function(params){
                try{
                    if(params.data.demmurage_end_date !='' && params.data.demmurage_end_date !=undefined)
                    {
                        return getHyphenDDMMYYYY(params.data.demmurage_end_date);
                    }
                }
                catch(e){
                }
            }          
        },
        {
            headerName: "Reason For Delay",
            field: "reason_for_delay",
            width:120,
            filter: true,
            resizable: true,          
        },
    ]

        
    return (
        <div class="row">
            <SweetAlert
                show={this.state.show}
                type={this.state.basicType}
                title={this.state.basicTitle}
                onConfirm={this.closeAlert}
            >
            </SweetAlert>
            <div className="col-xl-12">
                <div id="myGrid" style={{width:"100%",height:"478px"}} className={"ag-theme-balham"}>
                <AgGridReact
                    modules={this.state.modules}
                    //columnDefs={columnwithDefs}
                    columnDefs={columnwithDefs}
                    defaultColDef={this.state.defaultColDef}
                    rowData={this.props.chaRowData}
                    enableCharts={false}
                    // autoGroupColumnDef={this.state.autoGroupColumnDef}
                    onGridReady={this.onRecommGridReady}
                    onGridState={this.onRecommGridState}
                    frameworkComponents={this.state.frameworkComponents}
                    statusBar={this.state.statusBar}
                    sideBar={this.state.sideBar}
                    stopEditingWhenGridLosesFocus= {true}
                    paginationPageSize={this.state.paginationPageSize}
                    pagination={true}
                    gridOptions={{
                        context: { componentParent: this }
                    }}
                    onCellClicked={this.viewDetails.bind(this)}
                    // components={this.state.components}
                    />
                </div>
            </div>
            <div className={"slide-r "+(this.state.bulkslide)} style={{overflow:"hidden"}}>
            <h3 className="subH">
                {this.state.sliderTitle}
                <span className="float-right fclose" style={{marginRight:"12px",padding:"1px 8px",marginTop:"-2px"}} onClick={this.onClickHideAll.bind(this)}>x</span>
            </h3>
            <div className="slide-r-body" style={{position:"relative"}}>
                {(this.state.invoiceData.length > 0) ?                         
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <table className="table table-bordered tptinfo">
                                    <thead>
                                        <tr>
                                            <th>Documents</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.invoiceData.map((e, index) => (
                                        <tr>
                                            <td style={{cursor:"pointer"}} onClick={() => this.downloadRingiFile(e.invoice_file)}>{e.invoice_file}</td>
                                        </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                : ""}
                {(this.state.ccSlider == 1) ?                         
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <table className="table table-bordered tptinfo">
                                    <thead>
                                        <tr>
                                            <th>Documents</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.ccData.map((e, index) => (
                                        <tr>
                                            <td style={{cursor:"pointer"}} onClick={() => this.downloadRingiFile(e.custom_clearance_file)}>{e.custom_clearance_file}</td>
                                        </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {(this.state.jobNo != "") ?
                                <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadCCFileFormHandler} style={{marginTop:"2%"}}>
                                    <div className="form-group">
                                        <label className="">Upload New Document</label>
                                        <input type="file" name="other_docs" id="other_docs" className="form-control" onChange={this.changeDocFileHandler} required/>
                                    </div>

                                    <div className="form-group">
                                        <button type="submit" className="btn btn-success">Submit</button>
                                    </div>
                                </form>
                                : ""} 
                            </div>
                        </div>
                    </div>
                : ""}
            </div>
        </div>
        </div>
        

    );
  }
}